import { render, staticRenderFns } from "./ItsStockRawAddInventoryDetail.vue?vue&type=template&id=15dc75d1&scoped=true&"
import script from "./ItsStockRawAddInventoryDetail.vue?vue&type=script&lang=js&"
export * from "./ItsStockRawAddInventoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsStockRawAddInventoryDetail.vue?vue&type=style&index=0&id=15dc75d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dc75d1",
  null
  
)

export default component.exports